/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ movement: NonNullable<unknown> }} Prescription_Notice_Pattern_MissingInputs */

const en_us2_prescription_notice_pattern_missing = /** @type {(inputs: Prescription_Notice_Pattern_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No ${i?.movement} exercise this week: none fits your equipment and restrictions.`)
};

const pt_br2_prescription_notice_pattern_missing = /** @type {(inputs: Prescription_Notice_Pattern_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nenhum exercício de ${i?.movement} nesta semana: nenhum cabe no seu equipamento e restrições.`)
};

const es_419_prescription_notice_pattern_missing = /** @type {(inputs: Prescription_Notice_Pattern_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ningún ejercicio de ${i?.movement} esta semana: ninguno se ajusta a tu equipo y tus restricciones.`)
};

const pt_pt2_prescription_notice_pattern_missing = /** @type {(inputs: Prescription_Notice_Pattern_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nenhum exercício de ${i?.movement} esta semana: nenhum se adequa ao teu equipamento e restrições.`)
};

const fr_fr2_prescription_notice_pattern_missing = /** @type {(inputs: Prescription_Notice_Pattern_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pas d'exercice « ${i?.movement} » cette semaine : aucun ne convient à ton équipement et à tes restrictions.`)
};

const de_de2_prescription_notice_pattern_missing = /** @type {(inputs: Prescription_Notice_Pattern_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diese Woche keine Übung für ${i?.movement}: Keine passt zu deiner Ausstattung und deinen Einschränkungen.`)
};

const it_it2_prescription_notice_pattern_missing = /** @type {(inputs: Prescription_Notice_Pattern_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessun esercizio di ${i?.movement} questa settimana: nessuno è compatibile con la tua attrezzatura e le tue restrizioni.`)
};

/**
* | output |
* | --- |
* | "No {movement} exercise this week: none fits your equipment and restrictions." |
*
* @param {Prescription_Notice_Pattern_MissingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_notice_pattern_missing = /** @type {((inputs: Prescription_Notice_Pattern_MissingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Notice_Pattern_MissingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_notice_pattern_missing(inputs)
	if (locale === "es-419") return es_419_prescription_notice_pattern_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_notice_pattern_missing(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_notice_pattern_missing(inputs)
	if (locale === "de-DE") return de_de2_prescription_notice_pattern_missing(inputs)
	if (locale === "it-IT") return it_it2_prescription_notice_pattern_missing(inputs)
	return en_us2_prescription_notice_pattern_missing(inputs)
});
export { prescription_notice_pattern_missing as "prescription.notice.pattern_missing" }